require('./aggregatorAddEntityStepPSD2.scss')

// @ vendors
import PropTypes from 'prop-types';
import React from 'react';

// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
import { AggregatorBeta } from 'components/aggregator/aggregatorBeta/aggregatorBeta';

// @constants
const {
    recordPath,
    recordLink,
    PROC_AGGREGATOR_RENEW_FIRST_SESSION, 
    PROC_AGGREGATOR_RENEW_SESSION, 
    PROC_FIRST_STEP,
    PROC_AGGREGATOR_RENEW_FIRST_SESSION_GO_TO,
    PROC_AGGREGATOR
} = require('utilities/tagging');

class AggregatorAddEntityStepPSD2 extends React.PureComponent {

    componentDidMount() {
        const { bankUniqueId, requestUrl } = this.props;
        requestUrl(bankUniqueId);
        recordPath(PROC_AGGREGATOR_RENEW_FIRST_SESSION, null,PROC_AGGREGATOR_RENEW_SESSION, PROC_FIRST_STEP)
    }

    componentWillUnmount() {
        const { initStorePSD2, name } = this.props;
        recordLink(PROC_AGGREGATOR, `${PROC_AGGREGATOR_RENEW_FIRST_SESSION_GO_TO}' '${name}`)
        initStorePSD2();
    }

    render() {
        const { url, name, beta } = this.props;

        return (
            <OKSectionBox
                className="aggregator-add-entity-psd2__go-to-credentials"
                title={formatText('aggregatorPSD2-goToBankTitle', [name])}
                titleSeparator
            >
                <div className="aggregator-add-entity-psd2__go-to-credentials__information-wrapper">
                    <div className="aggregator-add-entity-psd2__go-to-credentials__text">
                        <FormattedText value="aggregatorPSD2-goToBankInformation"/>
                    </div>
                    <div className="aggregator-add-entity-psd2__go-to-credentials__text" >
                        <FormattedText value="aggregatorPSD2-goToBankButtonIndication" injectedStrings={[name]}/>
                    </div>
                </div>
                <div className="aggregator-add-entity-psd2__go-to-credentials__logo-bank-wrapper">
                    <img className="aggregator-add-entity-psd2__go-to-credentials__logo-bank" src={url} />
                    {beta && <AggregatorBeta tooltipTextKey="aggregatorBeta-selectBankTooltip"/>}
                </div>
            </OKSectionBox>
        );
    }
}

AggregatorAddEntityStepPSD2.defaultProps = {
    name: '',
    beta: false,
}

AggregatorAddEntityStepPSD2.propTypes = {
    name: PropTypes.string,
    bankId: PropTypes.string,
    bankUniqueId: PropTypes.string,
    beta: PropTypes.bool,
    getDataBank: PropTypes.func,
    url: PropTypes.string,
    requestUrl: PropTypes.func,
    initStorePSD2: PropTypes.func,
}

export default AggregatorAddEntityStepPSD2;